<template>
  <div class="qrcode-doctor">
      <p class="doctor-title">医生专属二维码</p>
      <div class="qrcode-box">
          <img :src="code" alt="">
      </div>
      <!-- <div class="share-btn">
        <button>立即分享</button>
      </div> -->
  </div>
</template>
<script>
export default {
  name: 'qrcode',
  data () {
    return {
      code: localStorage.getItem('code')
    }
  }
}
</script>
<style lang='less' scoped>
.qrcode-doctor {
  height: 100vh;
  text-align: center;
  background: url(../assets/images/j-i13.png) top center no-repeat #61b0e3;
  -webkit-background-size: 100% auto;
  background-size: 100% auto;
  overflow: hidden;
  .doctor-title{
    width: 100%;
    height:36px;
    font-size:18px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    color:rgba(255,255,255,1);
    line-height:36px;
    margin-top: 44px;
  }
  .qrcode-box{
    width: 100%;
    margin-top: 20px;
    img{
      width: 55%;
      margin: 0 auto;
    }
  }
  .share-btn {
    margin-top: 30px;
    button{
      width:80px;
      height:30px;
      line-height: 30px;
      background:rgba(97,176,227,1);
      border:1px solid rgba(255, 255, 255, 1);
      opacity:0.5;
      border-radius:29px;
      color: #fff;
      font-size: 12px;
      outline: none;
    }
    
  }
}
</style>


